import React from 'react';
import { FormattedMarkdown } from '@qover/react-intl';
import { Trans } from '@lingui/react';

export default {
  termsAgreements: (
    generalConditions: string,
    ipid: string,
    privacyPolicyLink: string,
  ) => (
    <FormattedMarkdown
      id="general.termsAgreements"
      values={{
        url1: generalConditions,
        url2: privacyPolicyLink,
        url3: ipid,
      }}
    />
  ),
  termsAgreementsTitle2: <Trans id="general.termsOfService2" />,
  termsAgreements2: (
    generalConditions: string,
    ipid: string,
    privacyPolicyLink: string,
  ) => (
    <FormattedMarkdown
      id="general.termsAgreements2"
      values={{
        url1: generalConditions,
        url2: privacyPolicyLink,
        url3: ipid,
      }}
    />
  ),
};
